import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import '../styles/AllProjects.css';
import projectsData from './projectdetails/projectsData';

const AllProjects = () => {
  // Define site title and links specific to the AllProjects page
  const allProjectsPageLinks = [
    { text: 'HOME', to: '/' },
    { text: 'ABOUT', to: '/about' },
    { text: 'PROJECTS', to: '/all_projects' },
    { text: 'GALLERY', to: '/#gallery' },
    { text: 'CONTACT', to: '/#contact' }
  ];

  return (
    <section className='allprojects_sec'>
      {/* Reuse the Header component with specific site title and links */}
      <Header links={allProjectsPageLinks} />
      
      <h1 className='all_projects_h'>PROJECTS</h1>
      <div className='all_projects_images'>
        {projectsData.map((project, index) => (
          <div className="project-container" key={index}>
            <a href={`/project-details/${project.slug}`}>
              <img className='project_image' src={project.images[0]} alt={project.name} /> 
              <p className="image-text">{String(index + 1).padStart(2, '0')}</p>
            </a> 
          </div>
        ))}
      </div>

      <Footer />
    </section>
  );
};

export default AllProjects;
